export default __webpack_public_path__ + "static/media/gallery-11.5165f594.jpg";